<template>
  <single-panel-page>
    <div v-show="inProgress">
      <p>We are now activating your account ...</p>
      <loader />
    </div>

    <div v-show="!inProgress && activationDone" class="animated fadeIn">
      <p class="text-success">
        Congrats! You have successfully activated your access. We have sent you
        a link to your inbox - use it to log into the platform.
      </p>
      <!-- <p class="text-muted">
        You can optionally use
        <router-link :to="{ name: 'login' }"> login page </router-link>.
      </p> -->
      <!-- <loader/> -->
    </div>

    <div v-show="!inProgress && !activationDone" class="animated fadeIn">
      <p v-show="userAlreadyActive" class="text-info">
        This link has been already used. Please use login page.
      </p>
      <router-link
        v-show="userAlreadyActive"
        :to="{ name: 'login' }"
        class="btn btn-primary"
      >
        Click to login
      </router-link>
      <p v-show="!userAlreadyActive" class="text-warning">
        There was an error during access activation. Please
        <a href="mailto:support@vestbee.com">contact us</a>
        if this repeats.
      </p>
    </div>
  </single-panel-page>
</template>

<script>
import Auth from 'services/Auth'
import { sleep } from '@/utils'

export default {
  props: {
    userId: { type: String, default: null },
    eventId: { type: String, default: null },
    token: { type: String, default: null },
    privateToken: { type: String, default: null },
  },
  data() {
    return {
      inProgress: true,
      activationDone: false,
      userAlreadyActive: false,
    }
  },
  async created() {
    const self = this

    const request = Auth.activateForEvent({
      userId: this.userId,
      eventId: this.eventId,
      token: this.token,
    })
    await sleep(1000)
    try {
      await request
      self.activationDone = true
      self.inProgress = false
      // TODO: somehow store that upon next login this user should be redirected
      // to proper showroom's (using eventId from props)
      return
    } catch (error) {
      self.activationDone = false
      self.inProgress = false
      if (
        error.response.data.token &&
        error.response.data.token[0] ===
          'Wrong combination or token already used'
      ) {
        self.userAlreadyActive = true
      }
    }
  },
}
</script>
